type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> &
  React.AnchorHTMLAttributes<HTMLAnchorElement> & {
    className?: string;
    href?: string;  
  };

function Button(props: ButtonProps) {
  const { children, className = "", href, ...restProps } = props;
  const baseClasses =
    "sm:text-main text-blue-main rounded-[14px] sm:rounded-xl bg-white-main sm:px-[32px] sm:py-[14px] text-center hover:opacity-90 active:opacity-80 font-medium! py-4 px-[28px] leading-[80%] text-main-mobile min-w-[240px] transition-all duration-300 ease-in-out block cursor-pointer font-normal";

  if (href) {
    return (
      <a href={href} className={`${baseClasses} ${className}`} {...restProps}>
        {children}
      </a>
    );
  }

  return (
    <button className={`${baseClasses} ${className}`} {...restProps}>
      {children}
    </button>
  );
}

export default Button;
